import { useAppStore } from '../store/useAppStore.js';
import { useSettingsStore } from '../store/useSettingsStore.js';

// Pure role derivation, mirroring the server role model:
// - BAKER_PIN + SESSION_ID: baker = valid PIN, customer = valid session, else anonymous
// - BAKER_PIN only:          baker = valid PIN, else customer
// - SESSION_ID only:         baker = valid session, else anonymous
// - neither:                 everyone is baker
// Fail-open while server config is unknown (pinConfigured === null): the
// server still enforces credentials on every mutation.
export function deriveRole({ pinConfigured, sessionConfigured, pinValidated, sessionValidated }) {
  if (pinConfigured === null) {
    return 'baker';
  }
  if (pinConfigured) {
    return pinValidated ? 'baker' : 'customer';
  }
  if (sessionConfigured === true) {
    return sessionValidated ? 'baker' : 'anonymous';
  }
  return 'baker';
}

export function useRole() {
  const pinConfigured = useAppStore((state) => state.pinConfigured);
  const sessionConfigured = useAppStore((state) => state.sessionConfigured);
  const pinValidated = useSettingsStore((state) => state.pinValidated);
  const sessionValidated = useSettingsStore((state) => state.sessionValidated);
  return deriveRole({ pinConfigured, sessionConfigured, pinValidated, sessionValidated });
}
